"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsSelectElementOption_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsDataElementType_1 = require("./EFormsDataElementType");
var EFormsSelectElementOption_Factory = /** @class */ (function () {
    function EFormsSelectElementOption_Factory() {
    }
    EFormsSelectElementOption_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DataElementId: model.DataElementId,
            NonTechnicalResponseText: model.NonTechnicalResponseText,
            OptionText: model.OptionText,
            PromptElementType: EFormsDataElementType_1.EFormsDataElementType_Factory.CreateIncoming(model.PromptElementType),
            PromptElementTypeCode: model.PromptElementTypeCode,
            PromptText: model.PromptText,
            Rank: model.Rank,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TechnicalResponseText: model.TechnicalResponseText,
        };
        return result;
    };
    EFormsSelectElementOption_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DataElementId: model.DataElementId,
            NonTechnicalResponseText: model.NonTechnicalResponseText,
            OptionText: model.OptionText,
            PromptElementType: EFormsDataElementType_1.EFormsDataElementType_Factory.CreateOutgoing(model.PromptElementType),
            PromptElementTypeCode: model.PromptElementTypeCode,
            PromptText: model.PromptText,
            Rank: model.Rank,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TechnicalResponseText: model.TechnicalResponseText,
        };
        return result;
    };
    return EFormsSelectElementOption_Factory;
}());
exports.EFormsSelectElementOption_Factory = EFormsSelectElementOption_Factory;
